import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Axios from "../../axios/axios"; // Assuming Axios is correctly configured
import { toast } from "react-toastify";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import { toTitleCase } from "../../components/utils/StringUtil";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const customerId = JSON.parse(
        sessionStorage.getItem("userInfo")
      ).customerId;
      const response = await Axios.get(`/orders/${customerId}`);
      console.log(response.data);

      const businessType = sessionStorage
        .getItem("businessType")
        ?.toLowerCase();
      const validStatuses = [
        "quotation requested",
        "quotation given",
        "quotation review",
        "quotation_requested",
      ];

      const filteredOrders = response.data
        .filter((order) =>
          order.orderItems.some((item) =>
            item.productType.some((pt) => pt.toLowerCase() === businessType)
          )
        )
        .filter((order) =>
          validStatuses.includes(order.orderStatus?.toLowerCase())
        )
        .sort((a, b) => new Date(b.orderDate) - new Date(a.orderDate));

      setOrders(filteredOrders);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch customer orders:", error);
      setLoading(false);
    }
  };

  const handleCancelOrder = async (id) => {
    try {
      const res = await Axios.delete(`/order/delete/${id}`);
      alert(res.data.message);
      fetchOrders(); // Refresh orders after cancellation
    } catch (error) {
      if (error.response) {
        alert(error.response.data.message);
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to cancel order. Please try again.");
      }
    }
  };

  if (loading) {
    return <p>Loading orders...</p>;
  }
  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  return (
    <div style={sectionStyle}>
      {/* <Header /> */}

      <div className="Main-div">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
        <section className="orders">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb p-0">
                <li>
                  <a href="search-result.html" className="back">
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>{" "}
                    &nbsp;&nbsp;
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/account">Account</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Your orders
                </li>
              </ol>
            </nav>
            <div className="row">
              <div className="col-lg-7">
                <h3 className="text-uppercase mb-5">Your Orders</h3>
              </div>
              <div className="col-lg-5">
                <div className="form-row order-search">
                  <div className="col-lg-8">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by serial number"
                      />
                      <div className="input-group-append">
                        <button className="btn search-btn" type="button">
                          <i className="fa fa-search" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <select
                        className="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected>Past 6 months</option>
                        <option>Past 1 year</option>
                        <option>Past 1 week</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table search-table">
                <tbody>
                  <tr>
                    <td colSpan="8" className="border-td p-0">
                      <table className="table search-inner-table head-table">
                        <tbody>
                          <tr>
                            <th className="align-middle" width="110">
                              Serial No.
                            </th>
                            <th className="align-middle" width="110">
                              Product
                            </th>
                            <th className="align-middle" width="80">
                              Status
                            </th>
                            <th className="align-middle" width="80">
                              Date
                            </th>
                            {/* <th className="align-middle" width="80">
                            Price
                          </th> */}
                            <th className="align-middle" width="100">
                              Details
                            </th>
                            <th className="align-middle" width="130">
                              Track
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  {/* Map through the filtered orders and display them */}
                  {orders?.length > 0 ? (
                    orders.map((order, index) => (
                      <tr key={order._id}>
                        <td colSpan="8" className="border-td p-0">
                          <table className="table search-inner-table">
                            <tbody>
                              <tr>
                                <td className="align-middle" width="110">
                                  {index + 1} {/* Serial number */}
                                </td>
                                {/* <td className="align-middle" width="110">
                                {toTitleCase(order.orderItems
                                  .map((item) => item.productName))}
                                  
                              </td> */}
                                <td className="align-middle" width="110">
                                  {order.orderItems
                                    .map((item) =>
                                      toTitleCase(item.productName)
                                    )
                                    .join(", ")}
                                </td>
                                <td
                                  className="align-middle"
                                  width="110"
                                  style={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {toTitleCase(order.orderStatus)}
                                </td>
                                <td className="align-middle" width="80">
                                  {order.orderDate}
                                </td>
                                {/* <td className="align-middle" width="80">
                                ₹{order.totalAmount}
                              </td> */}
                                <td className="align-middle" width="100">
                                  <Link
                                    to={`/order/${order._id}`}
                                    className="text-primary text-decoration-none"
                                    style={{
                                      textDecoration: "none",
                                      color: "black",
                                    }}
                                  >
                                    View order details
                                  </Link>
                                </td>
                                <td className="align-middle" width="100">
                                  <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                      if (
                                        window.confirm(
                                          "Are you sure you want to cancel this order?"
                                        )
                                      ) {
                                        handleCancelOrder(order._id);
                                      }
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center" colSpan="6">
                        No orders found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default Orders;
